import LoginButton from "../buttons/LoginButton";
import SignupButton from "../buttons/SignupButton";
import Image from "next/image";
import Logo from "../images/The_Boho_Market_Logo.png";
import mainLogo from "../../public/images/mainLogo.svg";

const LandingHeader = () => {
  return (
    <div className="header header-container ">
      <div className="wrapper-90 header__content">
        <div className="header__logo">
          <Image
            src={mainLogo}
            alt="logo"
            height="70"
            width="220"
          />
        </div>
        <div className="header__navbar regular__navbar">
          <SignupButton />
          <LoginButton />
        </div>
      </div>
    </div>
  );
};

export default LandingHeader;
